
import { createRoot } from 'react-dom/client'
import { lazy, Suspense, StrictMode } from 'react'
import './index.css'

// Create a simple loading component with minimal styling
const Loading = () => (
  <div className="h-screen w-screen flex items-center justify-center bg-white">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-piano-gold border-t-transparent rounded-full animate-spin mx-auto"></div>
      <p className="mt-4 text-gray-600">Indlæser...</p>
    </div>
  </div>
)

// Import App directly instead of lazy loading to avoid potential module loading issues
import App from './App'

// Create root and render App with Suspense
const rootElement = document.getElementById("root");

if (rootElement) {
  // Create the root once
  const root = createRoot(rootElement);
  
  // Render the app
  root.render(
    <StrictMode>
      <Suspense fallback={<Loading />}>
        <App />
      </Suspense>
    </StrictMode>
  )
}

// Load non-critical resources after main content
window.addEventListener('load', () => {
  // Add polyfills or non-critical resources here
  if ('requestIdleCallback' in window) {
    // @ts-ignore - older TypeScript may not have requestIdleCallback types
    window.requestIdleCallback(() => {
      // Load any non-critical resources during idle time
    });
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(() => {
      // Load any non-critical resources after a delay
    }, 2000);
  }
});
